import { GetArpMediaParams } from '../../../__legacy__/api/v2/ArpMediaAPI'

export type GetSongRemixesParams = Omit<
  GetArpMediaParams,
  'isDefaultSample' | 'type' | 'subType' | 'instrumentCategory'
>
